import { User } from "../users/user.model";

export class Chat {
    constructor(public image: string,
                public author: string,
                public authorStatus: string,
                public text: string,
                public date: Date,
                public my: boolean) { }
}

export class ChatP {
    public id: number;
    public from: User;
    public to: User;
    public message: string;
    public sent: boolean;
    public received: boolean;
    public seen: boolean;
    public status: number = 0;
    public my: boolean;
    public created_at: Date;
    messages: ChatP[];
    countNewMessage: number = 0;
    active: boolean;
    typing: boolean; 

    constructor(from: User = null, to: User = null, message: string = '', my: boolean = false, sent: boolean = false, received: boolean = false, seen: boolean = false, created_at: Date = new Date()) {
        this.from = from;
        this.to = to;
        this.message = message;
        this.my = my;
        this.sent = sent;
        this.received = received;
        this.seen = seen;
        this.created_at = created_at;
    }

} 